/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import {
    Button,
    Table,
    Input,
    Form,
    Row,
    Col,
    Icon,
    Modal,
    message,
    InputNumber,
    Rate,
    DatePicker,
    Select,
} from 'antd';
import { services } from '@comall-backend-builder/core';
import { navigation } from '@comall-backend-builder/core/lib/services';
import { errorHandle } from '../../services';
import './index.less';
import { isArray } from 'lodash';
import moment from 'moment';
const api = services.api;
const { confirm } = Modal;
const { RangePicker } = DatePicker;
const { Option } = Select;

const SunbathingOrderComponent: React.FC<any> = ({ form }) => {
    const [tableData, setTableData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
    const [expand, setExpand] = useState(false);
    const [total, setTotal] = useState<any>(0);
    const [sortValue, setSortValue] = useState<any>('');
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [visible, setVisible] = useState<any>(false);
    const [showPreview, setShowPreview] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    useEffect(() => {
        const defaultPage = 1;
        const defaultPageSize = 10;
        try {
            const fromSunbathingOrder = sessionStorage.getItem('fromSunbathingOrder');
            // 如果是详情页返回
            if (fromSunbathingOrder) {
                const SUNBATH_SEARCH = sessionStorage.getItem('SUNBATH_SEARCH');
                const searchParams = JSON.parse(SUNBATH_SEARCH) || {};
                const {
                    page = defaultPage,
                    per_page = defaultPageSize,
                    startDate,
                    endDate,
                    ...SEARCH
                } = searchParams;
                setPageNum(page);
                setPageSize(per_page);

                if (startDate && endDate) {
                    SEARCH.date = [moment(startDate), moment(endDate)];
                }
                form.setFieldsValue({
                    ...SEARCH,
                });
                loadSknList(page, per_page);
            } else {
                loadSknList(defaultPage, defaultPageSize);
            }
        } catch (err) {
            loadSknList(defaultPage, defaultPageSize);
        }

        sessionStorage.setItem('fromSunbathingOrder', '');
    }, []);

    const filterUndefined = (obj: any) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
            if (obj[key] !== undefined && obj[key] !== '') {
                newObj[key] = obj[key];
            }
        });
        return newObj;
    };

    // 获取数据
    const loadSknList = (page: number, per_page: number) => {
        setLoading(true);
        const searchValue = form.getFieldsValue();
        const params: any = filterUndefined(searchValue);
        const createTime = params?.date || [];
        if (isArray(createTime) && createTime.length) {
            params.startDate = createTime[0].format('YYYY-MM-DD');
            params.endDate = createTime[1].format('YYYY-MM-DD');
            delete params.date;
        }
        api.get({ ...params, page, per_page }, { apiPath: `/review_list` })
            .then((res: any) => {
                const SEARCH = { ...params, page, per_page };
                sessionStorage.setItem('SUNBATH_SEARCH', JSON.stringify(SEARCH));
                const { result, totalNum } = res;
                setTableData(result || []);
                setLoading(false);
                setTotal(totalNum);
            })
            .catch(errorHandle);
    };

    const onSelectChange = (selectedRowKeys: any[]) => {
        setSelectedRowKeys(selectedRowKeys);
    };

    const getFields = () => {
        const { getFieldDecorator } = form;
        const children = [
            <Col span={8}>
                <Form.Item label={`晒单内容`} labelCol={{ span: 8 }}>
                    {getFieldDecorator(`content`)(<Input placeholder="请输入" />)}
                </Form.Item>
            </Col>,
            <Col span={8}>
                <Form.Item label={`会员账户`} labelCol={{ span: 8 }}>
                    {getFieldDecorator(`loginName`)(<Input placeholder="请输入" />)}
                </Form.Item>
            </Col>,
            <Col span={8}>
                <Form.Item label={`发布晒单时间`} labelCol={{ span: 8 }}>
                    {getFieldDecorator('date')(<RangePicker />)}
                </Form.Item>
            </Col>,
            <Col span={8}>
                <Form.Item label={`显示状态`} labelCol={{ span: 8 }}>
                    {getFieldDecorator('showStatus')(
                        <Select placeholder="请选择">
                            <Option value="0">显示</Option>
                            <Option value="1">隐藏</Option>
                        </Select>
                    )}
                </Form.Item>
            </Col>,
            <Col span={8}>
                <Form.Item label={`sku`} labelCol={{ span: 8 }}>
                    {getFieldDecorator(`skuCode`)(<Input placeholder="请输入" />)}
                </Form.Item>
            </Col>,
            <Col span={8}>
                <Form.Item label={`款号`} labelCol={{ span: 8 }}>
                    {getFieldDecorator(`styleCode`)(<Input placeholder="请输入" />)}
                </Form.Item>
            </Col>,
            <Col span={8} style={{ display: expand ? 'block' : 'none' }}>
                <Form.Item label={`商品名称`} labelCol={{ span: 8 }}>
                    {getFieldDecorator(`skuName`)(<Input placeholder="请输入" />)}
                </Form.Item>
            </Col>,
            <Col span={8} style={{ display: expand ? 'block' : 'none' }}>
                <Form.Item label={`评分`} labelCol={{ span: 8 }}>
                    {getFieldDecorator(`star`)(
                        <Select mode="multiple" placeholder="请选择">
                            <Option value="5">5星</Option>
                            <Option value="4">4星</Option>
                            <Option value="3">3星</Option>
                            <Option value="2">2星</Option>
                            <Option value="1">1星</Option>
                        </Select>
                    )}
                </Form.Item>
            </Col>,
            <Col span={8} style={{ display: expand ? 'block' : 'none' }}>
                <Form.Item label={`是否追评`} labelCol={{ span: 8 }}>
                    {getFieldDecorator(`secondaryStatus`)(
                        <Select placeholder="请选择">
                            <Option value="1">已追评</Option>
                            <Option value="0">未追评</Option>
                        </Select>
                    )}
                </Form.Item>
            </Col>,
        ];
        return children;
    };

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        setPageNum(1);
        loadSknList(1, pageSize);
    };

    // 点击重置按钮
    const handleReset = () => {
        form.resetFields();
        setPageNum(1);
        loadSknList(1, pageSize);
    };

    const toggle = () => {
        setExpand(!expand);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    /**
     * 调用成功后触发
     * @param value
     */
    const handleSuccessReset = (value: string) => {
        message.success(value);
        setSelectedRowKeys([]);
        loadSknList(pageNum, pageSize);
    };

    // 查看
    const handleSee = (record: { id: any }) => {
        let path = `/content/sunbathingOrder/detail/${record.id}`;
        navigation.goto(path);
    };

    // 编辑
    const handleEdit = (record: { id: any }) => {
        let path = `/content/sunbathingOrder/edit/${record.id}`;
        navigation.goto(path);
    };

    const handlePreview = (item: any) => {
        setPreviewImage(item);
        setShowPreview(true);
    };

    const columns: any[] = [
        {
            title: '晒单内容',
            dataIndex: 'content',
            width: 200,
            ellipsis: true,
            render: (content: any) => {
                return (
                    <div
                        style={{
                            whiteSpace: 'pre-line',
                            lineHeight: 1.8,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical',
                        }}
                    >
                        {content ? content.replace(/ /g, '\u00a0') : '-'}
                    </div>
                );
            },
        },
        {
            title: '晒单图片',
            dataIndex: 'picList',
            width: 90,
            render: (picList: string | undefined) => {
                const imgUrl = Array.isArray(picList) ? picList[0] : '';
                // eslint-disable-next-line jsx-a11y/alt-text
                return imgUrl ? (
                    <div onClick={() => handlePreview(imgUrl)}>
                        <img width={45} height={45} src={imgUrl} />
                    </div>
                ) : (
                    '--'
                );
            },
        },
        {
            title: '获得点赞',
            dataIndex: 'praiseCount',
            width: 90,
            align: 'center',
            render: (praiseCount: any) => {
                return (
                    <div
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <Icon type="heart" style={{ marginRight: '4px' }} />
                        {praiseCount}
                    </div>
                );
            },
        },
        {
            title: '会员账户',
            dataIndex: 'loginName',
            width: 120,
        },
        {
            title: '发布晒单时间',
            dataIndex: 'createTimeStr',
            width: 180,
        },
        {
            title: '显示状态',
            dataIndex: 'showStatus',
            width: 80,
            render: (showStatus: any) => {
                return showStatus === 1 ? (
                    <div className="hide-icon">隐藏</div>
                ) : (
                    <div className="display-icon">显示</div>
                );
            },
        },
        {
            title: (
                <div>
                    排序
                    <br />
                    （数字越大越靠前）
                </div>
            ),
            dataIndex: 'sortValue',
            width: 140,
            align: 'center',
        },
        {
            title: '晒单SKU',
            dataIndex: 'skuCode',
            width: 200,
        },
        {
            title: '商品款号',
            dataIndex: 'styleCode',
            width: 120,
        },
        {
            title: '商品名称',
            dataIndex: 'skuName',
            width: 160,
        },
        {
            title: '订单编号',
            dataIndex: 'orderNo',
            width: 170,
        },
        {
            title: '评分',
            dataIndex: 'star',
            width: 170,
            render: (star: any) => {
                return <Rate allowHalf disabled value={star} />;
            },
        },
        {
            title: '是否追评',
            dataIndex: 'secondaryStatus',
            width: 100,
            render: (secondaryStatus: any) => {
                return secondaryStatus === 1 ? '已追评' : '未追评';
            },
        },
        {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 120,
            align: 'center',
            render: (_: any, record: any) => (
                <>
                    <a type="link" onClick={() => handleSee(record)}>
                        查看
                    </a>
                    <a
                        style={{ display: 'inline-block', marginLeft: '12px' }}
                        type="link"
                        onClick={() => handleEdit(record)}
                    >
                        编辑
                    </a>
                </>
            ),
        },
    ];

    // 批量显示
    const handleBatchDisplay = () => {
        if (!selectedRowKeys.length) {
            message.warning('请至少选择1条数据再操作');
            return;
        }
        confirm({
            centered: true,
            title: '确认批量设置为显示？',
            content: `已选${selectedRowKeys.length}条数据，已隐藏的数据将会批量设置为显示。`,
            onOk() {
                api.put(
                    { updateType: 'DISPLAY', list: selectedRowKeys },
                    { apiPath: `/review_list/show_status` }
                )
                    .then(() => {
                        handleSuccessReset('设置显示成功！');
                    })
                    .catch(errorHandle);
            },
            onCancel() {},
        });
    };

    // 批量隐藏
    const handleBatchHidden = () => {
        if (!selectedRowKeys.length) {
            message.warning('请先选择数据！');
            return;
        }
        confirm({
            centered: true,
            title: '确认批量设置为隐藏？',
            content: `已选${selectedRowKeys.length}条数据，已显示的数据将会批量设置为隐藏。`,
            onOk() {
                api.put(
                    { updateType: 'HIDE', list: selectedRowKeys },
                    { apiPath: `/review_list/show_status` }
                )
                    .then(() => {
                        handleSuccessReset('设置隐藏成功！');
                    })
                    .catch(errorHandle);
            },
            onCancel() {},
        });
    };

    // 批量排序
    const handleBatchSort = () => {
        if (!selectedRowKeys.length) {
            message.warning('请先选择数据！');
            return;
        }
        setVisible(true);
    };

    const onShowSizeChange = (_current: any, size: any) => {
        setPageNum(1);
        setPageSize(size);
        loadSknList(1, size);
    };

    useEffect(() => {
        setSortValue('');
    }, [visible]);

    // 改变分页
    const handlePageChange = (current: number, size: number) => {
        setPageNum(current);
        setPageSize(size);
        loadSknList(current, size);
    };

    return (
        <div className="sunbathing-box">
            <Form
                className="ant-advanced-search-form"
                style={{ marginBottom: '24px' }}
                onSubmit={handleSearch}
            >
                <Row gutter={24}>{getFields()}</Row>
                <Row>
                    <Col span={12}>
                        <Button onClick={handleBatchDisplay}>批量显示</Button>
                        <Button style={{ marginLeft: 8 }} onClick={handleBatchHidden}>
                            批量隐藏
                        </Button>
                        <Button style={{ marginLeft: 8 }} onClick={handleBatchSort}>
                            批量排序
                        </Button>
                    </Col>

                    <Col span={12} style={{ textAlign: 'right' }}>
                        <Button type="primary" htmlType="submit">
                            查询
                        </Button>
                        <Button style={{ marginLeft: 8 }} onClick={handleReset}>
                            重置
                        </Button>
                        <a style={{ marginLeft: 8, fontSize: 12 }} onClick={toggle}>
                            {expand ? '收起' : '展开'} <Icon type={expand ? 'up' : 'down'} />
                        </a>
                    </Col>
                </Row>
            </Form>
            <Table
                rowSelection={rowSelection}
                scroll={{ x: 2000 }}
                rowKey="id"
                loading={loading}
                columns={columns}
                dataSource={tableData}
                pagination={{
                    current: pageNum, //当前页码
                    pageSize, // 每页数据条数
                    showSizeChanger: true,
                    showQuickJumper: false,
                    pageSizeOptions: ['10', '15', '20'],
                    total: total,
                    onShowSizeChange: onShowSizeChange,
                    onChange: handlePageChange,
                    showTotal: (total, range) => `第${range[0]}-${range[1]}条/总共${total}条`,
                }}
            />

            <Modal
                width={400}
                centered
                visible={visible}
                title="批量设置排序"
                onCancel={() => {
                    setVisible(false);
                }}
                footer={[
                    <Button
                        key="back"
                        onClick={() => {
                            setVisible(false);
                        }}
                    >
                        取消
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={loading}
                        onClick={() => {
                            if (!sortValue) {
                                message.warning('排序值不能为空');
                                return;
                            }
                            api.put(
                                { sortValue: sortValue, list: selectedRowKeys },
                                { apiPath: `/review_list/sort` }
                            )
                                .then(() => {
                                    handleSuccessReset('批量设置排序成功！');
                                    setVisible(false);
                                })
                                .catch(errorHandle);
                        }}
                    >
                        确定
                    </Button>,
                ]}
            >
                <div className="sunbathing-sort">
                    <div className="sort-title">
                        已选{selectedRowKeys.length}条数据，将会批量更新为以下排序。
                    </div>
                    <div className="sort-content">
                        <div className="label">设置排序：</div>
                        <div className="value">
                            <InputNumber
                                max={999}
                                min={1}
                                value={sortValue}
                                placeholder="请输入数值"
                                onChange={(e) => {
                                    setSortValue(e);
                                }}
                                precision={0}
                            />
                            {!sortValue && <div className="value-errIcon">排序值不能为空</div>}
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                visible={showPreview}
                footer={null}
                width={500}
                style={{ textAlign: 'center' }}
                onCancel={() => {
                    setShowPreview(false);
                    setTimeout(() => {
                        setPreviewImage('');
                    }, 20);
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <img style={{ width: '100%' }} src={previewImage} alt="" />
                </div>
            </Modal>
        </div>
    );
};

export const SunbathingOrder = Form.create<any>()(SunbathingOrderComponent);
export default SunbathingOrder;
